import { BaseDynamicFormElement } from '../../model';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DynamicFormControlService } from '../../service/dynamic-form-control.service';
import { DynamicFormElementComponent } from './form-element/dynamic-form-element.component';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil, tap } from 'rxjs';

@Component({
  selector: 'form-base',
  templateUrl: './dynamic-form.component.html',
  providers: [DynamicFormControlService],
  imports: [CommonModule, ReactiveFormsModule, DynamicFormElementComponent],
})
export class DynamicFormComponent implements OnInit, OnDestroy {
  @Input() public form!: FormGroup;
  @Input() public formElements: BaseDynamicFormElement<string>[] = [];
  @Input() public model!: Record<string, unknown>;
  @Output() public modelChanges = new EventEmitter<FormGroup>();
  private destroyed$: Subject<boolean> = new Subject();

  constructor(private formControlService: DynamicFormControlService) {}

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }

  public ngOnInit(): void {
    this.formControlService.toFormGroup(this.formElements as BaseDynamicFormElement<string>[], this.form);
    this.form.valueChanges
      .pipe(
        tap((value) => this.modelChanges.emit(value)),
        takeUntil(this.destroyed$),
      )
      .subscribe();
    this.form.updateValueAndValidity();
  }
}
